import type { Block, BlockType } from '@/components/canvas/blocks/types';
import type { AnyBlockDefinition, BlockDefinition, BlockInsertMenuItem } from './types';

const registry = new Map<BlockType, AnyBlockDefinition>();

export function registerBlockDefinition<T extends Block>(def: BlockDefinition<T>): void {
  registry.set(def.type, def as unknown as AnyBlockDefinition);
}

export function getBlockDefinition(type: BlockType): AnyBlockDefinition | undefined {
  return registry.get(type);
}

export function hasBlockDefinition(type: string): type is BlockType {
  return registry.has(type as BlockType);
}

export function getBlockInsertMenuItems(): BlockInsertMenuItem[] {
  return [...registry.values()].map((d) => d.menuItem);
}

export function getBlockInspectorTitle(block: Block): string {
  return getBlockDefinition(block.type)?.label ?? '功能块';
}

export function estimateBlockContentSize(block: Block): { width: number; height: number } {
  const def = getBlockDefinition(block.type);
  if (!def) return { width: block.layout.width, height: block.layout.height };
  return def.estimateContentSize(block.data as never);
}

export function getBlockMinSize(type: BlockType): { width: number; height: number } {
  const def = getBlockDefinition(type);
  return def?.minSize ?? { width: 40, height: 40 };
}

export function isBlockContentInteractive(type: BlockType): boolean {
  const def = getBlockDefinition(type);
  return def?.contentInteractive === true || def?.presentationInteractive === true;
}

/** @deprecated 使用 isBlockContentInteractive */
export function isBlockPresentationInteractive(type: BlockType): boolean {
  return isBlockContentInteractive(type);
}
